import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Step } from '../standalone-components/steps/model/steps';
import { AppointmentCreationService } from './service/appointment-creation.service';

@Component({
  selector: 'app-appointment-creation',
  templateUrl: './appointment-creation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppointmentCreationComponent {
  readonly currentStep$ = this.appointmentCreationService.currentStep$;
  readonly steps: Step[] = [
    {
      title: $localize`Motive`,
      step: 1,
    },
    {
      title: $localize`Identification`,
      step: 2,
    },
    {
      title: $localize`Confirmation`,
      step: 3,
    },
  ];

  constructor(
    private readonly appointmentCreationService: AppointmentCreationService,
  ) {}
}
